module.exports = __webpack_public_path__ + "static/img/sms-recharge.00926ae7.jpg";